module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-shadow-4.04c9baec.png";